import { omitBy, isNil } from 'lodash';

const response = (data) => {
    const street1= data.profile.primaryAddress?.street1 ?? ''
    const street2= data.profile.primaryAddress?.street2 ?? ''
    const city= data.profile.primaryAddress?.city ?? ''
    const state= data.profile.primaryAddress?.state ?? ''
    const postcode= data.profile.primaryAddress?.postcode ?? ''
    const country= data.profile.primaryAddress?.country ?? ''

    return omitBy({
        locationName:data?.loc ? (data?.loc.locationName ?? data?.loc.orgName) : null,
        location:data?.loc ? data?.loc._id : null,
        org: data?.org ? {
            logisticProviderOrgID: data.org.logisticProviderOrgID,
            name: data.org.name,
            orgType: data.org.orgType,
            id:data.org._id,
        } :
        null,
        profile:{
            id:data.profile._id,
            orgID:data.profile.orgID,
            fullName:data.profile.fullName,
            idPassportNo:data.profile?.identification?.no,
            idPassportType:data.profile?.identification?.type,
            email:data.profile.primaryEmail,
            pendingEmail:data.profile.pendingEmail,
            mobileNo:{
                dialCode:data.profile.primaryPhone.countryCode,
                number:data.profile.primaryPhone.number,
                fullNumber:`+`+data.profile.primaryPhone.fullNumber,
            },
            street1:street1,
            street2:street2,
            city:city,
            state:state,
            postcode:postcode,
            country:country,
            fullAddress:street1 + ' ' + (street2 || '') + ' ' + city + ' ' + state + ' ' + postcode + ' ' + country,
            gender:data.profile?.gender,
            nric_passport:data.userRole?.data?.attachments?.[0], /**because `FetchedUserProfile` type need */
        },
        userRole:{
            orgID:data.userRole?.orgID,
            accountType:data.userRole.data?.accountType,
            approvalStatus:data.userRole.data?.approvalInfo?.approvalStatus,
            code:data.userRole.data?.code,
            department:data.userRole.data?.department,
            onlineStatus:data.userRole.data?.onlineStatus,
            isDeactivated:data.userRole.data?.tempDeleteInfo,
            status:data.userRole.status,
            subType:(data.userRole.subType).replace(/_/g, " "),
            type:data.userRole.type,
            bankType:data.userRole.data.payrollDetails?.bankType,
            accountNo:data.userRole.data.payrollDetails?.accountNumber,
            socsoNo:data.userRole.data.payrollDetails?.socsoNo,
            epfNo:data.userRole.data.payrollDetails?.epfNo,
            incomeTax:data.userRole.data.payrollDetails?.incomeTax,
            hrdfNo:data.userRole.data.payrollDetails?.hrdfNo,
            zakatNo:data.userRole.data.payrollDetails?.zakatNo,
            emergencyContactName:data.userRole.data?.emergancyContactName, /**ask BE to change typo */
            emergencyContactNo:{
                dialCode:data.userRole.data?.emergancyContactNumber?.countryCode,
                number:data.userRole.data?.emergancyContactNumber?.number,
                fullNumber:data.userRole.data?.emergancyContactNumber?.fullNumber ? `+`+data.userRole.data?.emergancyContactNumber.fullNumber : '-',
            },/**ask BE to change typo */
            relationship:data.userRole.data?.emergencyRelationship,
        }
    },isNil)
}

export default response;
